import React, { useState, useEffect, useCallback } from 'react'
import { Form, Input, InputOnChangeData } from 'semantic-ui-react'
import { Button, useAlert } from '@apex/component-library'
import { useToast } from '@chakra-ui/react'
import styles from './styles.module.less'
import { useFormatMessage } from '../../utils/intlHelpers'
import { useHistory } from 'react-router-dom'
import useGetSearchAccount from '../../api/useGetSearchAccount'

export const SearchBar = () => {
  const history = useHistory()
  const formatMessage = useFormatMessage()
  const [search, setSearch] = useState<string>('')
  const toast = useToast()
  const { setAlert, removeAllAlerts } = useAlert()

  const { refetch: searchAccount, data: searchResults, isLoading: loadingResults, error } = useGetSearchAccount(
    search.toUpperCase()
  )

  useEffect(() => {
    if (searchResults?.length === 1) {
      const accountNumber = searchResults[0]?.accountNumber
      if (accountNumber) {
        history.push({
          pathname: `/transfers/${accountNumber}`
        })
        if (!search) {
          setSearch(accountNumber)
        }
      }
    } else if (search && searchResults) {
      const accountsPath = `${window.location.origin}/accounts/#/search/${search}`
      window.location.assign(accountsPath)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchResults, searchResults])

  const handleSubmit = () => {
    toast.closeAll()
    removeAllAlerts()
    searchAccount()
  }

  const openAlert = useCallback(setAlert, [])
  useEffect(() => {
    if (error) {
      openAlert({
        title: 'System Unavailable',
        description: 'Sorry, this service is temporarily unavailable. Please check back later.',
        status: 'error',
        direction: 'row',
        isClosable: true,
        showIcon: true
      })
    }
  }, [openAlert, error])

  const canSearch = search && search.length >= 3

  return (
    <Form className={styles.searchBar} onSubmit={handleSubmit}>
      <Form.Group className={styles.searchBarFields}>
        <Form.Field width={5}>
          <label className={styles.searchLabel}>{formatMessage('accounts.search.label')}</label>
          <Input
            className='test-id-search-input'
            icon='search'
            placeholder={formatMessage('accounts.search.placeholder')}
            value={search}
            aria-label='search'
            onChange={(e: React.SyntheticEvent, data: InputOnChangeData) => {
              setSearch(data.value)
            }}
            required={true}
          />
        </Form.Field>
        <Button
          className={`${styles.searchBtnField} search-btn`}
          variant='primary'
          type='submit'
          isDisabled={!canSearch}
          isLoading={loadingResults}
          marginBottom='2px'
        >
          {formatMessage('accounts.search')}
        </Button>
      </Form.Group>
    </Form>
  )
}
